import {
    ExpertiseStreamOrderDataItem,
    ExpertiseStreamState,
    initialExpertiseStreamState,
} from './ExpertiseStreamState';
import { createRpcStreamReducer } from 'widgets/store/rpcStream/reducer';
import {
    ExpertiseResponse,
    ExpertiseResponseDataItem,
    UnreliableDateResponse,
} from 'communication/types/expertise/ExpertiseResponse';
import isDate from 'lodash/isDate';

export const expertiseStreamReducer = createRpcStreamReducer<
    ExpertiseStreamState,
    ExpertiseResponse
>(initialExpertiseStreamState, (response) => ({
    orderData: response.orderData
        ? response.orderData.map(mapOrderDataItem)
        : [],
    messages: response.msgs ? response.msgs.map((m) => ({ message: m })) : [],
}));

function mapOrderDataItem(
    responseItem: ExpertiseResponseDataItem
): ExpertiseStreamOrderDataItem {
    return {
        ...responseItem,
        date: safeMapDate(responseItem.Date),
        lastTradeTime: safeMapDate(responseItem.LastTradeTime),
        startTime: safeMapDate(responseItem.StartTime),
        endTime: safeMapDate(responseItem.EndTime),
    };
}

function safeMapDate(
    responseDate?: UnreliableDateResponse
): number | undefined {
    if (!responseDate) {
        return undefined;
    }
    if (isDate(responseDate)) {
        return responseDate.getTime();
    }
    if (typeof responseDate === 'number') {
        return responseDate;
    }
    try {
        return new Date(responseDate).getTime();
    } catch {
        return undefined;
    }
}
